import { Component, h } from '@stencil/core';

@Component({
  tag: 'signet-h2',
  styleUrl: 'signet-h2.scss',
  shadow: true,
})
export class SignetH2 {
  render() {
    return <h2><slot /></h2>;
  }
}
